// Shared UI utilities for consistent formatting and behaviors across the app

// Known placeholder asset that exists in repo (update if moved)
export const PLACEHOLDER_IMG = '/images/placeholder.svg';

// Prevent infinite image onError loops and swap to placeholder
export function safeImageOnError(event, fallbackUrl = PLACEHOLDER_IMG) {
	const img = event?.currentTarget;
	if (!img) return;
	img.onerror = null;
	img.src = fallbackUrl;
}

// Format currency consistently (defaults to INR)
export function formatCurrency(value, currency = 'INR', locale = 'en-IN') {
	const num = Number(value || 0);
	try {
		return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 2 }).format(num);
	} catch (_) {
		// Fallback when Intl not available or currency unsupported
		return `₹${num.toLocaleString(locale)}`;
	}
}

// Unified status-to-color mapping (Ant Design color tokens)
export function getStatusColor(status) {
	switch ((status || '').toLowerCase()) {
		case 'confirmed':
		case 'success':
			return 'green';
		case 'pending':
		case 'processing':
			return 'orange';
		case 'cancelled':
		case 'rejected':
			return 'red';
		case 'quoted':
			return 'blue';
		default:
			return 'default';
	}
}

// Dietary tag colors used in Menu and Search
export function getDietaryTagColor(tag) {
	const map = {
		'Vegetarian': 'green',
		'Vegan': 'lime',
		'Jain': 'orange',
		'Gluten-Free': 'gold',
		'Dairy-Free': 'cyan',
		'Nut-Free': 'purple',
		'Halal': 'blue',
		'Kosher': 'geekblue',
		'Keto': 'magenta',
		'Low-Carb': 'volcano',
		'Diabetic-Friendly': 'green'
	};
	return map[tag] || 'default';
}
